import { ActionFetch } from '@/store/actionTypes'
import { API } from '@/store/apiPath'
import { AxiosRequest } from '@/store/axiosHelper'
import { MutationStore, MutationView } from '@/store/mutationTypes'

const request = {
  actions: {
    [ActionFetch.PROJECTS.PUBLICS.INDEX]: ({ commit }, pid) => {
      commit(MutationView.SET_LOADING_SCREEN, true)
      return AxiosRequest(API.projects.publics.index(pid))
        .then((res) => {
          const data = res.data
          if (data.success && data.data) {
            commit(MutationStore.PROJECTS.PUBLICS.INDEX, {
              pid,
              data: data.data,
            })
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.PROJECTS.PUBLICS.UPDATE]: ({ commit, rootState }, params) => {
      commit(MutationView.SET_LOADING_SCREEN, true)
      const user = rootState.cmsUser
      return AxiosRequest(
        API.projects.publics.update(params.id),
        { ...params.data, createdBy: user.id, updatedBy: user.id },
        user.token,
      )
        .then((res) => {
          commit(MutationView.SET_LOADING_SCREEN, false)
          return res.data
        })
        .catch((error) => {
          commit(MutationView.SET_LOADING_SCREEN, false)
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
        })
    },
  },
}

export default request
